<template>
    <div id="reportContainer" ref="reportContainer">
            <p class="text-capitalize font-weight-bold m-0 pt-0 mt-3">Sales Summary</p>
            <b-overlay :show="isBusy" rounded="sm" >
            <p class="text-capitalize">{{ reqData.msg }}</p>
                <div class="row" v-if="dataSalesSummaryReport">
                    <div class="col-md-6" v-if="sales">
                        <b-table-simple bordered hover small responsive>
                            <b-thead head-variant="none">
                                <b-tr>
                                    <b-th colspan="2">Daily Sales</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr>
                                    <b-th># Orders</b-th>
                                    <b-td>{{sales.orders}}</b-td>                                     
                                </b-tr>                      
                                <b-tr>
                                    <b-th># Items</b-th>
                                    <b-td>{{sales.items}}</b-td>                                     
                                </b-tr>
                                <b-tr><b-td colspan="2"></b-td></b-tr>                                                      
                                <b-tr>
                                    <b-th>Gross $ Sales Total</b-th>
                                    <b-td>{{$c2d(sales.grossSales) | currency}}</b-td>                                     
                                </b-tr>                                                                                      
                                <b-tr>
                                    <b-th>Avg $ Sale/Order</b-th>
                                    <b-td>{{$c2d(sales.averageSales)  | decimalNumber(2) | currency}}</b-td>                                     
                                </b-tr>                                                      
                                <b-tr>
                                    <b-th>Avg # Items/Order</b-th>
                                    <b-td>{{sales.averageItems  | decimalNumber(2)}}</b-td>                                     
                                </b-tr>                                            
                                <b-tr><b-td colspan="2"></b-td></b-tr>                                                                                                                                
                                <b-tr>
                                    <b-th>Credit/Refund</b-th>
                                    <b-td>{{$c2d(sales.refunds) | currency}}</b-td>                                     
                                </b-tr>                   
                                <b-tr><b-td colspan="2"></b-td></b-tr>                                                                                         
                                <b-tr>
                                    <b-th>Net Tax</b-th>
                                    <b-td>{{$c2d(sales.tax) | currency}}</b-td>                                     
                                </b-tr>                                                                                      
                                <b-tr>
                                    <b-th>Net Tax2</b-th>
                                    <b-td>{{$c2d(sales.tax2) | currency}}</b-td>                                     
                                </b-tr>                                                                                                                      
                                <b-tr>
                                    <b-th>Net Tip</b-th>
                                    <b-td>{{$c2d(sales.tips) | currency}}</b-td>                                     
                                </b-tr>                                                                                      
                            </b-tbody>
                        </b-table-simple>
                    </div>
                    <div class="col-md-6" v-if="items">
                        <b-table-simple bordered hover small responsive>
                            <b-thead head-variant="none">
                                <b-tr>
                                    <b-th>Top Items (Completed)</b-th>
                                    <b-th>$ Sales</b-th>
                                    <b-th># Qty</b-th>                                                                        
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(item) in items.rows" :key="item.itemName">
                                    <b-td class="text-left">{{item.itemName}}</b-td>
                                    <b-td>{{$c2d(item.sales) | currency}}</b-td>                                     
                                    <b-td>{{item.quantity}}</b-td>                                                                         
                                </b-tr>                                                     
                            </b-tbody>
                             <b-tfoot foot-variant="none">
                                 <b-tr v-bind="item = items.totals">
                                    <b-th>Top 10 Totals</b-th>
                                    <b-th>{{$c2d(item.sales) | currency}}</b-th>                                     
                                    <b-th>{{item.quantity}}</b-th>  
                                 </b-tr>
                             </b-tfoot>
                        </b-table-simple>
                    </div>
                    <div class="col-md-6" v-if="lostSales">
                        <b-table-simple bordered hover small responsive>
                            <b-thead head-variant="none">
                                <b-tr>
                                    <b-th>Lost Sales</b-th>
                                    <b-th>$ Sales</b-th>
                                    <b-th># Order</b-th>                                                                        
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr>
                                    <b-th>Rejected</b-th>
                                    <b-td>{{$c2d(lostSales.rejectedSales) | currency}}</b-td>                                     
                                    <b-td>{{lostSales.rejectedItems}}</b-td>                                                                         
                                </b-tr>
                                <b-tr>
                                    <b-th>Cancelled</b-th>
                                    <b-td>{{$c2d(lostSales.cancelledSales) | currency}}</b-td>                                     
                                    <b-td>{{lostSales.cancelledItems}}</b-td>                                                                         
                                </b-tr>
                                <b-tr>
                                    <b-th>Cancelled - Cust</b-th>
                                    <b-td>{{$c2d(lostSales.customerCancelledSales) | currency}}</b-td>                                     
                                    <b-td>{{lostSales.customerCancelledItems}}</b-td>                                                                         
                                </b-tr>                      
                            </b-tbody>
                        </b-table-simple>
                    </div>
                    <div class="col-md-6" v-if="paymentType">
                        <b-table-simple bordered hover small responsive>
                            <b-thead head-variant="none">
                                <b-tr>
                                    <b-th>Payment Type</b-th>
                                    <b-th>Charge Total</b-th>
                                    <b-th># Order</b-th>                                                                        
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(item) in paymentType" :key="item.name">
                                    <b-th>{{item.name}}</b-th>
                                    <b-td>{{$c2d(item.sales) | currency}}</b-td>                                     
                                    <b-td>{{item.orders}}</b-td>                                                                         
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </div>
                
                <div class="row" v-if="dataSalesSummaryReport && hourlySalesAm">
                    <div class="col-12">
                        <b-card class="text-center">
                            <div class="text-dark">
                                Order Sales Breakdown by Hour
                            </div>
                        </b-card>
                    </div>
                    <div class="col-md-6">
                        <b-table-simple bordered hover small responsive>
                            <b-thead head-variant="none">
                                <b-tr>
                                    <b-th>a.m.</b-th>
                                    <b-th>$ Sales</b-th>
                                    <b-th># Orders</b-th>
                                    <b-th>Tip</b-th>                                                                                                        
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(item) in hourlySalesAm" :key="item.time">
                                    <b-td>{{item.time}}</b-td>
                                    <b-td>{{$c2d(item.sales) | currency}}</b-td>                                     
                                    <b-td>{{item.orders}}</b-td>
                                    <b-td>{{$c2d(item.tips) | currency}}</b-td>                                                                         
                                </b-tr> 
                            </b-tbody>
                        </b-table-simple>
                    </div>
                    
                    <div class="col-md-6">
                        <b-table-simple bordered hover small responsive>
                            <b-thead head-variant="none">
                                <b-tr>
                                    <b-th>p.m.</b-th>
                                    <b-th>$ Sales</b-th>
                                    <b-th># Orders</b-th>
                                    <b-th>Tip</b-th>                                                                                                        
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="(item) in hourlySalesPm" :key="item.time">
                                    <b-td>{{item.time}}</b-td>
                                    <b-td>{{$c2d(item.sales) | currency}}</b-td>                                     
                                    <b-td>{{item.orders}}</b-td>
                                    <b-td>{{$c2d(item.tips) | currency}}</b-td>                                                                         
                                </b-tr> 
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </div>
                
                <div class="row" v-if="dataSalesSummaryReport && efficiency">                    
                    <div class="col-12">
                        <b-table-simple bordered hover small responsive>
                            <b-thead head-variant="none">
                                <b-tr>
                                    <b-th colspan="2">Order Completion Efficiency Time (in Minutes)</b-th>                                                                                                                                        
                                </b-tr>
                            </b-thead>
                            <b-tbody>   
                                <b-tr>
                                    <b-th>Placed-New</b-th>
                                    <b-td>{{efficiency.newTime | decimalNumber(2)}}</b-td>                                     
                                </b-tr>
                                <b-tr>
                                    <b-th>Placed-Confirmed</b-th>
                                    <b-td>{{efficiency.confirmedTime | decimalNumber(2)}}</b-td>                                     
                                </b-tr>
                                <b-tr>
                                    <b-th>Placed-Pack</b-th>
                                    <b-td>{{efficiency.packTime | decimalNumber(2)}}</b-td>                                     
                                </b-tr>
                                <b-tr>
                                    <b-th>Placed-Preparing</b-th>
                                    <b-td>{{efficiency.preparingTime | decimalNumber(2)}}</b-td>                                     
                                </b-tr>
                                <b-tr>
                                    <b-th>Placed-Ready</b-th>
                                    <b-td>{{efficiency.readyTime | decimalNumber(2)}}</b-td>                                     
                                </b-tr>                                
                            </b-tbody>
                            <b-tfoot>
                                <b-tr>
                                    <b-th>Average Order Completion Time</b-th>
                                    <b-th>{{efficiency.totalTime | decimalNumber(2)}}</b-th>                                     
                                </b-tr>                                
                            </b-tfoot>
                        </b-table-simple>
                    </div>
                                        
                </div>
                <span class="text-danger">{{msgError}}</span>
            </b-overlay>                
        </div>
</template>
<script>
export default {
    props:{
        reqData : {type: Object}
    },
    data(){
        return { 
            msgError : "", 
            fields: [
                {  key: 'last_name', sortable: true  },
                {  key: 'first_name', sortable: true  },
                {  key: 'age', label: 'Person age',  sortable: true, variant: 'danger'   }
            ],
           isBusy:false,
           dataSalesSummaryReport:null
        }
    },
    watch:{
        reqData : {
            deep: true,
            immediate: true,            
            handler() {
                this.salesSummaryReport()
            }
		}
    },
    computed:{
        efficiency(){
            return this.dataSalesSummaryReport ? this.dataSalesSummaryReport.efficiency : null
        },
        hourlySalesAm(){
            return this.dataSalesSummaryReport ? this.dataSalesSummaryReport.hourlySales.filter((item, index) => {return index < 12}) : null
        },
        hourlySalesPm(){
            return this.dataSalesSummaryReport ? this.dataSalesSummaryReport.hourlySales.filter((item, index) => {return index >= 12}) : null
        },
        items(){
            return this.dataSalesSummaryReport ? this.dataSalesSummaryReport.items : null
        },
        lostSales(){
            return this.dataSalesSummaryReport ? this.dataSalesSummaryReport.lostSales : null
        },
        paymentType(){
            return this.dataSalesSummaryReport ? this.dataSalesSummaryReport.paymentType : null
        },
        sales(){
            return this.dataSalesSummaryReport ? this.dataSalesSummaryReport.sales : null
        }
    },
    methods:{        
        salesSummaryReport() {
            this.msgError = ""
            this.dataSalesSummaryReport = null
            this.isBusy = true
            this.$store.dispatch('apiSalesSummaryReport', this.reqData)
                .then(_res => {
                    this.isBusy = false
                    if(_res.status){
                        this.dataSalesSummaryReport = _res.res
                    }
                }).catch((e)=>{
                    this.msgError = e.msgError;
                    this.isBusy = false
                })
        },
    },
    mounted(){
        this.salesSummaryReport()
    }       
}
</script>